import styled from 'styled-components'

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.neutralWhite};
  --audit-step-title-line-height: ${({ theme }) => theme.fontSize.sm}rem;
  --audit-icon-size: ${({ theme }) =>
    (theme.spacing.sm + theme.spacing.md) / 2 - theme.spacing.xxxs}rem;
  --audit-icon-wrapper-size: ${({ theme }) => theme.spacing.lg}rem;
  --audit-icon-gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const StepRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--audit-icon-gap);
  width: 100%;
`

export const StepIconWrapper = styled.div<{ $color?: string }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--audit-icon-wrapper-size);
  height: var(--audit-icon-wrapper-size);
  color: ${({ $color, theme }) => $color ?? theme.colors.neutralGray};

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: currentColor;
    border-radius: 50%;
    opacity: 0.1;
  }

  & > svg {
    position: relative;
    z-index: 1;
    width: var(--audit-icon-size);
    min-width: var(--audit-icon-size);
    height: var(--audit-icon-size);
    min-height: var(--audit-icon-size);
  }
`

export const StepBody = styled.div<{ $dashed: boolean; $isLast: boolean }>`
  position: relative;
  padding-left: calc(var(--audit-icon-wrapper-size) + var(--audit-icon-gap));
  min-height: ${({ theme }) => theme.spacing.sm}rem;
  margin-top: ${({ theme }) => theme.spacing.xs}rem;
  margin-bottom: ${({ theme }) => theme.spacing.md}rem;

  flex: 1;

  &::before {
    content: '';
    position: absolute;
    top: -${({ theme }) => theme.spacing.xs}rem;
    bottom: -${({ theme }) => theme.spacing.md}rem;
    left: calc(var(--audit-icon-wrapper-size) / 2 - 0.075rem);
    width: 0.15rem;
    border-radius: 999rem;
    background: ${({ theme }) => theme.colors.neutralGray};
    background-image: ${({ $dashed, theme }) =>
      $dashed
        ? `repeating-linear-gradient(
            0deg,  
            ${theme.colors.neutralWhite} 0,  
            ${theme.colors.neutralWhite} 0.325rem,  
            transparent 0.325rem,  
            transparent 0.65rem  
          )`
        : 'none'};
    display: ${({ $isLast }) => ($isLast ? 'none' : 'block')};
  }
`

export const StepContent = styled.div``

export const StepDescription = styled.div`
  margin: 0.2rem 0.4rem;
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  color: ${({ theme }) => theme.colors.metalGray};
`

export const ContentPillWrapper = styled.div<{ $isHoverable: boolean }>`
  display: flex;
  border: 1px solid ${({ theme }) => theme.colors.neutralGray};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  max-width: fit-content;
  padding: ${({ theme }) => theme.spacing.sm}rem;

  ${({ $isHoverable, theme }) =>
    $isHoverable &&
    `
    &:hover {
      background: ${theme.colors.neutralGray};
    }`}
`

export const ContentPillInfoWrapper = styled.div`
  svg {
    width: ${({ theme }) => theme.spacing.sm}rem;
    min-width: ${({ theme }) => theme.spacing.sm}rem;
    height: ${({ theme }) => theme.spacing.sm}rem;
    min-height: ${({ theme }) => theme.spacing.sm}rem;
  }
`

export const ContentPillData = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: fit-content;
  gap: ${({ theme }) => theme.spacing.xs}rem;

  & > svg {
    width: ${({ theme }) => theme.spacing.md}rem;
    min-width: ${({ theme }) => theme.spacing.md}rem;
    height: ${({ theme }) => theme.spacing.md}rem;
    min-height: ${({ theme }) => theme.spacing.md}rem;
    align-self: center;
    color: ${({ theme }) => theme.colors.neutralBlack};
  }
`

export const ContentPillText = styled.p`
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  color: ${({ theme }) => theme.colors.metalGray};
  margin: 0;

  &:hover {
    text-decoration: none;
  }
`

export const ContentSecondaryText = styled.p`
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  color: ${({ theme }) => theme.colors.metalGray};
  margin-bottom: ${({ theme }) => theme.fontSize.md}rem;
`
export const MultipleFilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  margin-bottom: ${({ theme }) => theme.spacing.md}rem;
`
